/* PR 46 review · D1 — an account the auditor added to the chart in an adjusting entry (aje_new_accounts.py: coa_mappings row
   with added_by_auditor true, mapping_source "Added by auditor (adjusting entry)") is marked on the FS Mapping row (this badge,
   one hook line in pages/FsMapping.jsx) and gets its own colour + translated label in the GL Import mapping table
   (CoaMappingTable.jsx: sourceChip). EN + AR here (big-file rule: FsMapping.jsx is over 1,500 lines). */
import React from "react";
import { UserPlus } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export const ABA_TEXT = {
  en: { badge: "Added by the auditor", title: "Added to the chart of accounts by an adjusting entry posted by the audit team." },
  ar: { badge: "أضافه المدقق", title: "أُضيف إلى دليل الحسابات بقيد تسوية رحّله فريق المراجعة." },
};

export const ABA_CHIP = "bg-violet-100 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300";
export const AUDITOR_SOURCE = "Added by auditor (adjusting entry)";

export function isAddedByAuditor(row) {
  return !!row && (row.added_by_auditor === true || row.mapping_source === AUDITOR_SOURCE);
}

/** The Source chip of the mapping table: the auditor's rows → violet + the translated label; others unchanged. */
export function sourceChip(row, source, colors, lang) {
  if (isAddedByAuditor(row)) return { label: (ABA_TEXT[lang] || ABA_TEXT.en).badge, cls: ABA_CHIP, auditor: true };
  return { label: source, cls: colors[source] || colors.Unmapped, auditor: false };
}

export default function AddedByAuditorBadge({ row, testid }) {
  const { lang } = useI18n();
  if (!isAddedByAuditor(row)) return null;
  const L = ABA_TEXT[lang] || ABA_TEXT.en;
  return (
    <span className={`ms-1 mt-0.5 inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-medium ${ABA_CHIP}`}
          title={L.title} data-testid={testid || `fs-added-by-auditor-${row.id}`}>
      <UserPlus className="h-3 w-3" /> {L.badge}
    </span>
  );
}
